var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transactions-ctn pb-6 mr-4"
  }, [_c('h4', {
    staticClass: "text-capitalize font-weight-bold title"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_tbya_transactions')))]), _vm.isATPEnabled ? _c('div', [_c('div', {
    staticClass: "mt-10 d-flex align-center flex-wrap"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "align-self-center mr-6",
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_vm._v("mdi-filter-variant")]), _c('v-select', {
    staticClass: "custom-select elevation-0 mr-6",
    attrs: {
      "items": _vm.sourceFilterOptions,
      "item-disabled": _vm.isItemDisabled,
      "label": "Source",
      "dense": "",
      "solo": "",
      "height": "40"
    },
    model: {
      value: _vm.selectedSource,
      callback: function ($$v) {
        _vm.selectedSource = $$v;
      },
      expression: "selectedSource"
    }
  }), _c('v-select', {
    staticClass: "custom-select elevation-0 mr-6",
    attrs: {
      "items": _vm.statusFilterOptions,
      "item-disabled": _vm.isItemDisabled,
      "label": "Status",
      "dense": "",
      "solo": "",
      "height": "40"
    },
    model: {
      value: _vm.selectedStatus,
      callback: function ($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1), _c('v-spacer'), _c('v-text-field', {
    staticClass: "transactions-search-field mt-4 mt-sm-0",
    attrs: {
      "outlined": "",
      "dense": "",
      "placeholder": _vm.$t('amazon_transparency_search_by'),
      "single-line": "",
      "persistent-hint": ""
    },
    on: {
      "input": _vm.handleSearchInput
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "black"
          },
          on: {
            "click": _vm.handleSearchIconClick
          }
        }, [_vm._v(" " + _vm._s(_vm.searchQuery ? 'mdi-close' : 'mdi-magnify') + " ")])];
      },
      proxy: true
    }], null, false, 3957706771),
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1), _c('div', {
    staticClass: "mt-6"
  }, [_c('v-data-table', {
    staticClass: "tbya-transactions-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.transactions,
      "loading": _vm.isLoadingTransactions,
      "options": _vm.options,
      "server-items-length": _vm.totalTransactions,
      "items-per-page": 10,
      "footer-props": {
        'items-per-page-text': '',
        'disable-items-per-page': true
      },
      "item-value": "id",
      "loading-text": _vm.$t('amazon_transparency_loading_transactions'),
      "hide-default-footer": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header.product_name",
      fn: function (_ref) {
        var header = _ref.header;
        return [_c('span', {
          staticClass: "text-no-wrap"
        }, [_vm._v(_vm._s(header.text))])];
      }
    }, {
      key: "item.status",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', {
          staticClass: "text-capitalize",
          class: _vm.utils.getStatusStyle(item.status.toLowerCase())
        }, [_vm._v(" " + _vm._s(_vm.utils.transformStatusText(item.status)) + " ")])];
      }
    }, {
      key: "item.sku",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "wrap-cell-text"
        }, [_vm._v(_vm._s(item.sku))])];
      }
    }, {
      key: "item.details",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-tooltip', {
          attrs: {
            "left": "",
            "content-class": "custom-tooltip"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref5) {
              var tooltipOn = _ref5.on,
                tooltipAttrs = _ref5.attrs;
              return [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function (_ref6) {
                    var menuOn = _ref6.on,
                      menuAttrs = _ref6.attrs;
                    return [_c('v-btn', _vm._g(_vm._b({
                      attrs: {
                        "icon": ""
                      },
                      on: {
                        "click": function ($event) {
                          return _vm.viewDetails(item);
                        }
                      }
                    }, 'v-btn', Object.assign({}, tooltipAttrs, menuAttrs), false), Object.assign({}, tooltipOn, menuOn)), [_c('v-icon', {
                      attrs: {
                        "color": "primary",
                        "size": "24"
                      }
                    }, [_vm._v("mdi-open-in-new")])], 1)];
                  }
                }], null, true)
              })];
            }
          }], null, true)
        }, [_c('span', {
          staticClass: "tooltip-text-color"
        }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_view_details')))])])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-end mt-5 mb-4"
        }, [_c('v-pagination', {
          staticClass: "flex-grow-0",
          attrs: {
            "length": _vm.totalPages,
            "total-visible": 7
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.options.page,
            callback: function ($$v) {
              _vm.$set(_vm.options, "page", $$v);
            },
            expression: "options.page"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2812435375)
  })], 1)]) : _vm._e(), !_vm.isATPEnabled ? _c('div', [_c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "content-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_auto_register')))]), _c('p', {
    staticClass: "content-text mt-6"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_already_register')))]), _vm._v(" " + _vm._s(_vm.$t('amazon_transparency_use_module')) + " ")]), _c('p', {
    staticClass: "mt-6 content-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_please_contact')) + " "), _c('a', {
    staticClass: "text-decoration-underline",
    attrs: {
      "href": "mailto:support@scantrust.com"
    }
  }, [_vm._v("support@scantrust.com")]), _vm._v(" " + _vm._s(_vm.$t('amazon_transparency_enable_feature')) + " ")])])]) : _vm._e(), _c('TransactionDetailDialog', {
    attrs: {
      "display-detail-dialog": _vm.displayDetailDialog,
      "transaction": _vm.selectedItem
    },
    on: {
      "update:displayDetailDialog": _vm.closeDialog
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }